import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import DeviceSettings from './device-settings-model'
import {
  CreateDeviceSettingsAsync,
  DeleteDeviceSettingsAsync,
  LoadDeviceSettingssAsync,
} from './deviceSettings-thunk'
const initialState: deviceSettingsSliceState = {
  deviceSettings: [],
  selected_deviceSettings: '',
  is_loading_deviceSettings: false,
  is_creating_deviceSettings: false,
  is_deleting_deviceSettings: false,
}
export interface deviceSettingsSliceState {
  deviceSettings: DeviceSettings[]
  selected_deviceSettings?: string
  is_loading_deviceSettings: boolean
  is_creating_deviceSettings: boolean
  is_deleting_deviceSettings: boolean
}
export const deviceSettingsSlice = createSlice({
  name: 'deviceSettings',
  initialState,
  reducers: {
    setSelecteddeviceSettings: (state, action) => {
      state.selected_deviceSettings = action.payload
    },
    clearStatedeviceSettings: (state) => {
      state.deviceSettings = []
      state.is_loading_deviceSettings = false
      state.is_creating_deviceSettings = false
      state.is_deleting_deviceSettings = false
    },
    mergedeviceSettings: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_deviceSettings = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.deviceSettings = merge(state.deviceSettings, payload) as any
        }
      }
    },

    add_deviceSettings: (state, action) => {
      if (action.payload) {
        state.deviceSettings = [...state.deviceSettings, action.payload]
      }
    },
    set_deviceSettings: (state, action) => {
      let { key, value, id } = action.payload
      state.deviceSettings = state.deviceSettings.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadDeviceSettingssAsync.pending, (state) => {
      state.is_loading_deviceSettings = true
    })
    builder.addCase(LoadDeviceSettingssAsync.fulfilled, (state, action) => {
      state.is_loading_deviceSettings = false
      if (action.payload) {
        state.deviceSettings = action.payload
      }
    })
    builder.addCase(LoadDeviceSettingssAsync.rejected, (state) => {
      state.is_loading_deviceSettings = false
    })
    builder.addCase(CreateDeviceSettingsAsync.pending, (state) => {
      state.is_creating_deviceSettings = true
    })
    builder.addCase(CreateDeviceSettingsAsync.fulfilled, (state) => {
      state.is_creating_deviceSettings = false
    })
    builder.addCase(CreateDeviceSettingsAsync.rejected, (state) => {
      state.is_creating_deviceSettings = false
    })
    builder.addCase(DeleteDeviceSettingsAsync.pending, (state) => {
      state.is_deleting_deviceSettings = true
    })
    builder.addCase(DeleteDeviceSettingsAsync.fulfilled, (state, action) => {
      state.is_deleting_deviceSettings = false
      if (state.deviceSettings) {
        state.deviceSettings = state.deviceSettings.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteDeviceSettingsAsync.rejected, (state) => {
      state.is_deleting_deviceSettings = false
    })
  },
})

export const {
  clearStatedeviceSettings,
  setSelecteddeviceSettings,
  set_deviceSettings,
  mergedeviceSettings,
  add_deviceSettings,
} = deviceSettingsSlice.actions

export const get_deviceSettings =
  (id?: string) =>
  (state: {
    deviceSettings: {
      deviceSettings: DeviceSettings[]
    }
  }): DeviceSettings | null => {
    let temp = state?.deviceSettings?.deviceSettings?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.deviceSettings?.deviceSettings[0] || null
  }
export const get_selected_deviceSettings = (state: {
  deviceSettings: deviceSettingsSliceState
}): DeviceSettings | null => {
  let id = state?.deviceSettings?.selected_deviceSettings
  let temp = state?.deviceSettings?.deviceSettings?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_deviceSettings = (state: {
  deviceSettings: {
    deviceSettings: DeviceSettings[]
  }
}): DeviceSettings[] => {
  let temp = state?.deviceSettings?.deviceSettings
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_deviceSettings_busy = (state: {
  deviceSettings: deviceSettingsSliceState
}) => {
  return (
    state?.deviceSettings.is_deleting_deviceSettings ||
    state?.deviceSettings.is_loading_deviceSettings ||
    state?.deviceSettings.is_creating_deviceSettings
  )
}
export const is_deleting_deviceSettings_busy = (state: {
  deviceSettings: deviceSettingsSliceState
}) => {
  return state?.deviceSettings.is_deleting_deviceSettings
}
export const is_loading_deviceSettings_busy = (state: {
  deviceSettings: deviceSettingsSliceState
}) => {
  return state?.deviceSettings.is_loading_deviceSettings
}
export const is_creating_deviceSettings_busy = (state: {
  deviceSettings: deviceSettingsSliceState
}) => {
  return state?.deviceSettings.is_creating_deviceSettings
}

export default deviceSettingsSlice.reducer
